import { Text } from '@belong/ui';

type TableHeaderProps = {
  title: string;
};

export const TableHeader = ({ title }: TableHeaderProps) => {
  return (
    <tr className="border-gray border border-solid ">
      <td className="border-gray bg-light-gray p-xs pt-xl sm:p-sm border border-solid">
        <Text variant="p1" fontWeight="semibold" className="sm:h3 text-left">
          {title}
        </Text>
      </td>
      <td className="border-gray bg-navy-translucent-light p-sm border border-solid"></td>
      <td className="border-gray bg-light-gray p-sm border border-r-0 border-solid"></td>
      <td className="bg-light-gray p-sm border-l-0" />
    </tr>
  );
};
